import axios from "axios";
import { APP_DISPLAY_ADS_API_ENDPOINT } from "../../../constants/api_urls";
import "./structures/apiResponseStructures";
import {getUserToken} from "../../../utils/functions/userToken";

/**
 * Extracts indexed or global error messages from the API response.
 *
 * @param {Object} errorObj - The error object returned from the API response.
 * @returns {CampaignErrorMessages} An object containing extracted error messages.
 */
export const extractErrorMessages = (errorObj) => {
    const errors = {};
        errors.finalURL = errorObj?.campaign_ads_creative.final_url?.[0]?.errorMessage || '';
        errors.campaignName = errorObj?.campaign_name?.errorMessage || '';
        errors.campaignLang = errorObj?.campaign_settings?.campaign_lang?.[0]?.errorMessage || '';
        errors.logoImage = errorObj?.campaign_ads_creative.logo_image?.[0]?.errorMessage || '';
        errors.imagesImage = errorObj?.campaign_ads_creative.marketing_image?.[0]?.errorMessage || '';
    return errors;
};

/**
 * Creates a new Display Ads campaign using the provided settings.
 *
 * @async
 * @function createDisplayAdsCampaign
 * @param {Object} params - The parameters required to create the campaign.
 * @param {string} params.accountId - The account ID.
 * @param {string} params.hotelId - The hotel ID.
 * @param {Object} params.campaignSettings - The campaign settings configuration.
 * @param {Object} params.campaignAdsCreative - The campaign ads creative content.
 * @returns {Promise<CampaignResponse>} The result of the campaign creation process.
 */
export const createDisplayAdsCampaign = async ({
    accountId,
    hotelId,
    campaignSettings,
    campaignAdsCreative,
}) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.put(
            `${APP_DISPLAY_ADS_API_ENDPOINT}/api/display-ads/add-campaign/`,
            {
                account_id: accountId,
                hotel_id: hotelId,
                campaign_settings: campaignSettings,
                campaign_ads_creative: campaignAdsCreative,
            },
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errors = extractErrorMessages(error?.response?.data || {});
        return { success: false, errors };
    }
};
